import actionTypes from './actionTypes';

export const setAlert = (message, type = 'danger', global = true) => {
  return {
    type: actionTypes.ALERT_SET,
    alert: { message, type, global },
  };
};

export const unsetAlert = () => {
  return {
    type: actionTypes.ALERT_DISMISS,
  };
};



// WEBPACK FOOTER //
// ./src/modules/shared/alert/actions.js